/**
 * Checks if `value` is a numeric string.
 *
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` can be converted to a number.
 * @example
 *
 * isNumericString('1')
 * // => true
 *
 * isNumeric(1234)
 * // => true
 *
 * isNumericString('abcd')
 * // => false
 *
 * isNumeric('123a')
 * // => false
 *
 * isNumeric('123.4')
 * // => false
 */
const isNumeric = (value) => {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    return /^-?\d+$/.test(value);
};

/**
 * Casts boolean string values "true" and "false" to their boolean equivalent `true` and `false`
 * An empty string `''` is interpreted as `true` since `checked` of `<input checked />` is assigned to `''`.
 * @param boolStr
 * @returns
 */
const stringBooleanToBoolean = (bool) => {
    if (typeof bool === 'boolean') {
        return bool;
    }
    if (typeof bool === 'string' && ['', 'true', 'false'].includes(bool)) {
        return bool !== 'false';
    }
    return false;
};

/**
 * Converts the clamp value to a numeric value.
 * The clamp value can be a string, number, or boolean.
 *
 * @param {string | number | boolean} clamp - The clamp value to be converted.
 * @returns {number | undefined} - The numeric value of the clamp value, or undefined if the conversion is not possible.
 */
function getNumericClampValue(clamp) {
    if (isNumeric(clamp)) {
        return Number(clamp);
    }
    if (typeof clamp === 'string' || typeof clamp === 'boolean') {
        return stringBooleanToBoolean(clamp) ? 1 : undefined;
    }
}
/**
 * Checks if the numeric clamp value is equal to 1, indicating a single line clamp.
 *
 * @param {number | undefined} clamp - The numeric clamp value.
 * @returns {boolean} - Returns true if the numeric clamp value is 1, false otherwise.
 */
function isSingleLineClamp(clamp) {
    if (typeof clamp === 'number') {
        return clamp === 1;
    }
    return false;
}
/**
 * Checks if the numeric clamp value is greater than 1, indicating a multi line clamp.
 *
 * @param {number | undefined} clamp - The numeric clamp value.
 * @returns {boolean} - Returns true if the numeric clamp value is greater than 1, false otherwise.
 */
function isMultiLineClamp(clamp) {
    if (typeof clamp === 'number') {
        return clamp > 1;
    }
    return false;
}

export { isSingleLineClamp as a, getNumericClampValue as g, isMultiLineClamp as i, stringBooleanToBoolean as s };
